export const SN_WISHLIST = 'wishlist'
export const WISH_ADD_ITEM = SN_WISHLIST + '/ADD'
export const WISH_DEL_ITEM = SN_WISHLIST + '/DEL'
export const WISH_DEL_ALL_ITEMS = SN_WISHLIST + '/DEL_ALL'
export const WISH_LOAD_WISH = SN_WISHLIST + '/LOAD'
export const SET_WISHLIST_LOADED = `${SN_WISHLIST}/SET_WISHLIST_LOADED`
